var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 8.00016H14.6666M1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668M1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668M14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335M7.99992 1.3335C9.66744 3.15906 10.6151 5.52819 10.6666 8.00016C10.6151 10.4721 9.66744 12.8413 7.99992 14.6668M7.99992 1.3335C6.3324 3.15906 5.38475 5.52819 5.33325 8.00016C5.38475 10.4721 6.3324 12.8413 7.99992 14.6668",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobGray);
export default __webpack_public_path__ + "static/media/glob_gray.c10aa9ef9eb51a6b7399f3085360a56a.svg";
export { ForwardRef as ReactComponent };